import KeyboardDismissView from "@app/hoc/KeyboardDismissView"
import ScreenWrapper from "@app/hoc/ScreenWrapper"
import { PrivateStackParamList } from "@app/navigationApp/types"
import AmountCard from "@app/sharedComponents/AmountCard"
import Button from "@app/sharedComponents/Button/Button"
import CommonHeader from "@app/sharedComponents/Header/Header"
import { ThemedText, ThemedView } from "@app/theme"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { ScrollView, StyleSheet } from 'react-native';
import { useAppDispatch, useAppSelector } from "@app/store/hooks"
import { useEffect, useState } from "react"
import { getApplicationId } from "../FetchPortfolio/utils"
import { endpoints } from "@app/api/apis"
import axios from "axios"
import gs from '../../styles/globalStyles';
import { AvailableCASMap, setAuthCAS, setAvailableCAS } from "@app/store/slices/applicationSlice"
import MutualFundsList from "./components/MutualFundsList/MutualFundsList"
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet"
import FetchPortfolio from "../FetchPortfolio/FetchPortfolio"
import handleApiErr from "@app/helper/handleApiErr"
import { showErrorSheet } from "@app/store/slices/errorSlice"
import ROUTE from "@app/navigationApp/routes"
import { updatePartnerParams } from "@app/store/slices/platformSlice"
import { trackEvent } from "@app/utils/amplitude"

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'UNLOCK_LIMIT_LANDING'>

const UnlockLimitLanding = ({ navigation, route }: ScreenProps) => {
    const { authCAS, availableCAS } = useAppSelector((state) => state.application);
    const { userDetails } = useAppSelector((state) => state.auth);
    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        trackEvent('RTA_FETCH_PAGE_VIEWED');
        if (!authCAS) {
            getPledgeLimit();
        } else {
            initialiseAvailableCAS();
        }
    }, []);

    useEffect(() => {
        if (authCAS) {
            initialiseAvailableCAS();
            if((authCAS?.availableCreditAmount ?? 0) >= (authCAS?.minimumEligibleLimit?.amount ?? 0)) {
                dispatch(updatePartnerParams({showCall:true}))
            }
        }
    }, [authCAS]);

    const initialiseAvailableCAS = () => {
        const updatedAvailableCAS: AvailableCASMap = {}
        const availableCAS = authCAS?.availableCAS;
        if (availableCAS) {
            availableCAS.forEach((item) => {
                updatedAvailableCAS[item.isinNo + '-' + item.folioNo] = {
                    ...item,
                    pledgedUnits: item.totalAvailableUnits
                };
            });
        }
        dispatch(setAvailableCAS(updatedAvailableCAS));
    }

    const getPledgeLimit = async () => {
        const applicationId = await getApplicationId(userDetails?.linkedApplications[0]?.applicationId);
        const url = endpoints.pledgeLimit + applicationId;
        axios.get(url).then((response) => {
            dispatch(setAuthCAS(response?.data?.stepResponseObject));
            if(response?.data?.stepResponseObject?.availableCreditAmount ?? 0 >= response?.data?.stepResponseObject?.minimumEligibleLimit?.amount) {
                dispatch(updatePartnerParams({showCall:true}))
            }
        }).catch((error) => {
            if(error?.data?.statusCode && handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    errorHeading: error?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
        });
    }

    const Body = () => {
        return (
            <ThemedView style={ls.bodyContainer} backgroundColor='bg-surface-primary'>
                <ThemedText
                    variant='h3s'
                    color='text-primary'
                    fontWeight='bold'
                >
                    Congratulations!
                </ThemedText>
                <ThemedText
                    variant='b2r'
                    color='text-primary'
                >
                    Your portfolio was evaluated successfully
                </ThemedText>
                <ThemedView style={{ height: 24 }}></ThemedView>
                <AmountCard
                    availableCreditAmount={authCAS?.availableCreditAmount || 0}
                    totalPortfolioAmount={authCAS?.totalPortfolioAmount || 0}
                />
                <ThemedView style={{ height: 24 }}></ThemedView>
                <ThemedText
                    variant='b3r'
                    color='text-secondary'
                    textAlign='center'
                >
                    Don’t see all your mutual funds?
                </ThemedText>
                <ThemedView style={{ height: 8 }}></ThemedView>
                <Button
                    eventName={'RTA_FETCH_GET_PORTFOLIO_CLICKED'}
                    label={'Get more portfolio'}
                    handlePress={() => {setIsVisible(true)}}
                    type={'SOLID'}
                    size='MD'
                    bg='bg-primary'
                    textColor='text-primary'
                    disabled={false}
                    buttonLoader={false}
                />
                <ThemedView style={{ height: 12 }}></ThemedView>
                <Button
                    eventName={'RTA_FETCH_CONTINUE_NEXTSTEP_CLICKED'}
                    label={'Continue to next step'}
                    handlePress={() => {
                        navigation.navigate(ROUTE.MF_PLEDGE_PORTFOLIO);
                    }}
                    type={'OUTLINED'}
                    size='MD'
                    bg='bg-primary'
                    textColor='text-primary'
                    disabled={false}
                    buttonLoader={false}
                />
                <ThemedView style={{ height: 24 }}></ThemedView>
                <ThemedView style={{ height: 1, backgroundColor: '#E5E7EB' }}></ThemedView>
                <ThemedView style={{ height: 24 }}></ThemedView>
                <ThemedText
                    variant='h5s'
                    color='text-primary'
                    fontWeight='bold'
                >
                    Credit limit by mutual fund
                </ThemedText>
                <MutualFundsList />
            </ThemedView>
        )
    }


    const getRtaToRetry = () => {
        const availableCAS = authCAS?.availableCAS || [];
        const rtaToRetry = availableCAS.some(cas => cas.assetRepository === 'CAMS') ? 'KARVY' : 'CAMS';
        return rtaToRetry;
    }

    const renderGetMorePortfolio = () => {
        return (
            //@ts-expect-error
            <BottomSheetContainer
                isVisible={isVisible}
                close={()=>{setIsVisible(false)}}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                //@ts-expect-error
                containerStyle={gs.setBg('#fefefe')}
            >
                {/* @ts-expect-error */}
                <FetchPortfolio navigation={navigation} route={route} 
                    retryingFetchPortfolio={true}
                    rtaToRetry={`${getRtaToRetry()}`}
                    onSuccessFetch={()=>{
                        setIsVisible(false);
                        setTimeout(() => {
                            navigation.navigate(ROUTE.MF_PLEDGE_PORTFOLIO);
                        }, 500);
                    }}
                />
            </BottomSheetContainer>
        )
    }

    return (
        <>
            <ScreenWrapper screenName={route.name}>
                    <ThemedView flex={1} style={{ backgroundColor: 'white' }}>
                        <CommonHeader
                            label=''
                            navigation={navigation}
                            pageName={route.name}
                        />
                        <ScrollView
                            showsVerticalScrollIndicator={false}
                        >
                            <Body />
                        </ScrollView>
                        {renderGetMorePortfolio()}
                    </ThemedView>
            </ScreenWrapper>
        </>
    )
}

export default UnlockLimitLanding;


const ls = StyleSheet.create({
    bodyContainer: {
        flex: 1,
        paddingHorizontal: 16,
        paddingVertical: 24,
    }
});